var _linearGradient, _circle, _rect, _linearGradient2, _rect2, _linearGradient3, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Nextjs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NRNx2IPDe7PJlJvrxOKgWa",
    x1: 24,
    x2: 24,
    y1: 43.734,
    y2: 4.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a070a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b4b4b"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19.734,
    fill: "url(#NRNx2IPDe7PJlJvrxOKgWa)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.023,
    height: 15.996,
    x: 15.992,
    y: 16.027,
    fill: "#fff"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NRNx2IPDe7PJlJvrxOKgWb",
    x1: 30.512,
    x2: 30.512,
    y1: 33.021,
    y2: 18.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#fff"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.953,
    height: 14.59,
    x: 29.035,
    y: 15.957,
    fill: "url(#NRNx2IPDe7PJlJvrxOKgWb)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NRNx2IPDe7PJlJvrxOKgWc",
    x1: 22.102,
    x2: 36.661,
    y1: 21.443,
    y2: 40.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#NRNx2IPDe7PJlJvrxOKgWc)",
    points: "36.781,38.094 34.168,39.09 15.992,16.027 19.508,16.027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Nextjs);
export default __webpack_public_path__ + "static/media/icons8-nextjs.638b6634b382c33dc51d1ca4eb5094d4.svg";
export { ForwardRef as ReactComponent };